import './assets/fonts/fonts.css';

export const light = 'Sora, monospace';
export const regular = 'Sora,  monospace';
export const semi = 'Proxima Nova Semibold, Helvetica, Arial, sans-serif';
export const mono = 'Sora, monospace';
